import React from 'react';
import gql from 'graphql-tag';
import {Query} from '@apollo/react-components';
import HomePage from './HomePage';
import ErrorPage from '../ErrorPage';

export const GET_ALL_SYSTEMS = gql`
  {
    systems{
      id
      type
			gangway
      status
      downtime
      alarmCategory
      location {
        timezone
        longitude
        latitude
      }
      project{
        code
        vessel
				owner{
          name
          email
        }
        client{
          company
        }
      }
      alarms{
        code
        category
        text
        start
      }
    }
  }
`;

class Home extends React.Component {

  state = {};

  static getDerivedStateFromError(error) {
    return {error};
  }

  render() {
    const {error: reactError} = this.state;
    return (
      <Query query={GET_ALL_SYSTEMS}>
        {({loading, error, data}) => {
          if (error || reactError) {
            return <ErrorPage error={error || reactError} />;
          }
          return <HomePage systems={data ? data.systems : []} loading={loading}/>;
        }}
      </Query>
    );
  }
}

export default Home;

